const $ = jQuery;

const SingleGallery = {
  init: function () {
    $(document).ready(function () {
      const buttons = document.querySelectorAll(".category-btn");
      const galleryImages = document.querySelectorAll(".gallery-images");
      const loadMoreBtn = document.querySelector(".btn-wrapper button");
      const IMAGES_PER_CLICK = 12;

      function showInitialImages(gallery) {
        const allImages = gallery.querySelectorAll("a");
        allImages.forEach((img, i) => {
          img.style.display = i < IMAGES_PER_CLICK ? "block" : "none";
        });
      }

      function showNextImages(gallery) {
        const hiddenImages = Array.from(gallery.querySelectorAll("a")).filter(
          (a) => a.style.display === "none"
        );
        for (let i = 0; i < IMAGES_PER_CLICK && i < hiddenImages.length; i++) {
          hiddenImages[i].style.display = "block";
        }
      }

      function updateLoadMoreVisibility(gallery) {
        const hiddenImages = Array.from(gallery.querySelectorAll("a")).filter(
          (a) => a.style.display === "none"
        );
        loadMoreBtn.style.display = hiddenImages.length > 0 ? "flex" : "none";
      }

      buttons.forEach((btn) => {
        const btnId = btn.dataset.index;

        btn.addEventListener("click", () => {
          buttons.forEach((b) => b.classList.remove("active"));
          btn.classList.add("active");

          galleryImages.forEach((gallery) => {
            const allImages = gallery.querySelectorAll("a");
            if (gallery.dataset.index === btnId) {
              gallery.classList.add("active");
              showInitialImages(gallery);
              updateLoadMoreVisibility(gallery);
            } else {
              gallery.classList.remove("active");
              allImages.forEach((img) => {
                img.style.display = "none";
              });
            }
          });
        });
      });
      if(loadMoreBtn){
        loadMoreBtn.addEventListener("click", () => {
          const activeGallery = document.querySelector(".gallery-images.active");
          if (!activeGallery) return;
          
          showNextImages(activeGallery);
          updateLoadMoreVisibility(activeGallery);
        });
      }

      const initialGallery = document.querySelector(".gallery-images.active");
      if (initialGallery) {
        showInitialImages(initialGallery);
        updateLoadMoreVisibility(initialGallery);
      }
    });
  },
};

export default SingleGallery;
